import { ICommutePopup } from '../store/commute_popup';
import { TIndexableObject } from './villages';

export type TDropdownObject = {
  [key: string]: string;
};

export interface IRange {
  min?: number;
  max?: number;
}

interface ISerpFilters {
  [key: string]: string;
}

export const SERP_HOUSE_MATERIAL: ISerpFilters = {
  block: '4',
  boards: '7',
  brick: '1',
  monolith: '2',
  monolithBrick: '8',
  panel: '3',
  stalin: '6',
  wood: '5',
};

export const SERP_WC_TYPE: ISerpFilters = {
  indoors: '1',
  outdoors: '2',
};

export const SERP_HEATING_TYPE: ISerpFilters = {
  coal: '3',
  fireplace: '5',
  gas: '2',
  stove: '4',
  without: '1',
};

export const SERP_COMMUNICATIONS: ISerpFilters = {
  drainage: 'drainage',
  electricity: 'electricity',
  gas: 'gas',
  water: 'water',
};

// Фильтры, которых никогда не будет в qs
export const EXCLUDED_FILTERS = ['pageSize', 'regionId'];

export const DEFAULT_STATION_DISTANCE = 10;

export const STATION_DISTANCES = [1, 5, DEFAULT_STATION_DISTANCE];

export const DEFAULT_ROAD_DISTANCE = 25;

export const ROAD_DISTANCES = [5, 10, DEFAULT_ROAD_DISTANCE];

export enum SavedFiltersIds {
  Location,
  SaleStatus,
  ReadyStatus,
  OtherCommunications,
  HouseMaterialType,
  FloorCount,
  Area,
  BuilderId,
  HeatingSourceType,
  WcLocationType,
  Road = 10,
  RoadDistance,
  GroupedRoad,
  Station,
  StationDistance,
  GroupedStation,
  CommuteDistance,
  BlackFriday,
}

export const UNIQUE_SAVED_FILTERS = [
  SavedFiltersIds.Location,
  SavedFiltersIds.RoadDistance,
  SavedFiltersIds.StationDistance,
];

export const SAVED_FILTERS_BY_VALUE = [SavedFiltersIds.Station];

export const ROAD_SAVED_FILTERS = [SavedFiltersIds.Road, SavedFiltersIds.GroupedRoad];

export const STATION_SAVED_FILTERS = [SavedFiltersIds.Station, SavedFiltersIds.GroupedStation];

export const SAVED_FILTERS_KEYS = [
  'areaFrom',
  'areaTo',
  'builderId',
  'floorCountFrom',
  'floorCountTo',
  'heatingSourceType',
  'houseMaterialType',
  'otherCommunications',
  'readyStatus',
  'road',
  'roadDistance',
  'saleStatus',
  'station',
  'stationDistance',
  'wcLocationType',
  'commuteDistanceType',
  'commuteKmFrom',
  'commuteKmTo',
];

export enum CommutePopupTabs {
  Roads = 'roads',
  Stations = 'stations',
}

export const DEFAULT_COMMUTE_POPUP: ICommutePopup = {
  activeTab: CommutePopupTabs.Roads,
  opened: false,
};

export const COMMUTE_POPUP_TAB_LABELS: TIndexableObject = {
  [CommutePopupTabs.Roads]: 'Шоссе',
  [CommutePopupTabs.Stations]: 'Ж/д станции',
};
